import { useGlobalStore } from '../../../Common/store';
import bindActions from '../../../Common/actions';
import assotiationReducer from '../../store/association/getCustomers';

const { actions } = assotiationReducer;

/**
 * useAssotiation Custom Hook
 */
const useAssotiation: any = () => {
	const { state , dispatch } = useGlobalStore();

	// List of Props
	const { association, getCustomers  } = state;

	// List of Actions
	const {
		handleReturnCustomersShortNameAndCode,
		handleAssociation
	} = actions;

	// Bind Actions
	const assoctiationFlowActions = bindActions({
		handleReturnCustomersShortNameAndCode,
		handleAssociation 
	}, dispatch);

	return { association, getCustomers , ...assoctiationFlowActions };
}

export default useAssotiation;
